import React from 'react';

import { Box } from '../Box';
import { dotStyles, rootStyles } from './ThinkingIndicator.styles';

export type ThinkingIndicatorSize = 'sm' | 'md' | 'lg';

export type ThinkingIndicatorProps = {
  /**
   * Size variant for the indicator.
   */
  size?: ThinkingIndicatorSize;
  /**
   * Additional CSS class names.
   */
  className?: string;
  /**
   * Dot color when at the animation peak.
   */
  activeColor?: string;
  /**
   * Dot color when idle.
   */
  inactiveColor?: string;
  /**
   * Number of dots to render.
   */
  dotCount?: 3 | 4;
};

const dotSizeBySize: Record<ThinkingIndicatorSize, string> = {
  sm: '3px',
  md: '4px',
  lg: '5px',
};

const peakScaleBySize: Record<ThinkingIndicatorSize, string> = {
  sm: '2.0',
  md: '2.1',
  lg: '1.9',
};

const ThinkingIndicator = ({
  size = 'md',
  className,
  activeColor = 'var(--color-neutral-700)',
  inactiveColor = 'var(--color-neutral-300)',
  dotCount = 4,
}: ThinkingIndicatorProps) => {
  const dotDelayOffsets = Array.from(
    { length: dotCount },
    (_, index) => `${index * 0.13}s`
  );

  return (
    <Box
      css={rootStyles}
      className={className}
      style={
        {
          '--ti-dot-size': dotSizeBySize[size],
          '--ti-peak-scale': String(peakScaleBySize[size]),
          '--ti-active-color': activeColor,
          '--ti-inactive-color': inactiveColor,
        } as React.CSSProperties
      }
    >
      {dotDelayOffsets.map((delay) => (
        <Box key={delay} css={dotStyles} style={{ animationDelay: delay }} />
      ))}
    </Box>
  );
};

export default ThinkingIndicator;
